<template>
  <div>
    <Toolbar>
      <template slot="left" >
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-clipboard-list</v-icon>{{ $t('profile.setupdefinition.definitionssub') }}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>

    <br />

    <div v-if="item" class="table-setupdefinitionsub-show">
      <v-simple-table>
        <template slot="default">
          <thead>
            <tr>
              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>

              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>

              <td><strong>{{ $t('profile.setupdefinition.tool') }}</strong></td>
              <td>
                                    {{ item['tool'].name }}
              </td>

              <td><strong>{{ $t('profile.setupdefinition.material') }}</strong></td>
              <td>
                                    {{ item['material'].name }}
              </td>
            </tr>

            <tr>
              <td><strong>{{ $t('profile.setupdefinition.nozzle') }}</strong></td>
              <td>
                                    {{ item['nozzle'].name }}
              </td>

            </tr>

          </tbody>
        </template>
      </v-simple-table>
    </div>

    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import AccessMixin from '../../mixins/AccessMixin';
import Toolbar from '../../components/Toolbar';

const servicePrefix = 'SetupDefinitionSub';

export default {
  name: 'SetupDefinitionSubShow',
  servicePrefix,
  components: {
      Loading,
      Toolbar
  },
  mixins: [ShowMixin,AccessMixin],
  computed: {
    ...mapFields('setupdefinitionsub', {
      isLoading: 'isLoading'
    }),
    ...mapGetters('setupdefinitionsub', ['find'])
  },
  methods: {
    ...mapActions('setupdefinitionsub', {
      deleteItem: 'del',
      reset: 'reset',
      retrieve: 'load'
    })
  }
};
</script>
